(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class YGBuyButtonsSummary extends HTMLElement {
    connectedCallback() {
      this.handleQuantityChange = this.handleQuantityChange.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.quantityInput?.addEventListener('input', this.handleQuantityChange);
      this.quantityInput?.addEventListener('change', this.handleQuantityChange);
      this.productForm?.addEventListener('variant:change', this.handleVariantChange);
      this.updateQuantityText();
    }

    disconnectedCallback() {
      this.quantityInput?.removeEventListener('input', this.handleQuantityChange);
      this.quantityInput?.removeEventListener('change', this.handleQuantityChange);
      this.productForm?.removeEventListener('variant:change', this.handleVariantChange);
    }

    get productForm() {
      const formId = this.getAttribute('data-product-form-id');
      return formId ? document.forms[formId] : null;
    }

    get quantityInput() {
      const inputId = this.getAttribute('data-quantity-input-id');
      return inputId ? document.getElementById(inputId) : null;
    }

    get moneyFormat() {
      return this.getAttribute('data-currency-code-enabled') === 'true'
        ? theme.settings.moneyWithCurrencyFormat
        : theme.settings.moneyFormat;
    }

    handleQuantityChange() {
      this.updateQuantityText();
    }

    handleVariantChange(event) {
      const variant = event.detail?.variant;
      if (!variant) return;

      this.updateVariantImage(variant);
      this.updateVariantPrice(variant);
      this.updateQuantityInputRules(variant);
      this.updateQuantityText();
    }

    updateQuantityText() {
      const target = this.querySelector('[data-yg-buy-buttons-quantity]');
      if (!target) return;

      const input = this.quantityInput;
      const min = parseInt(input?.getAttribute('min') || input?.dataset.min || '1', 10);
      const quantity = parseInt(input?.value || min || '1', 10);
      target.textContent = String(Number.isNaN(quantity) ? 1 : quantity);
    }

    updateVariantImage(variant) {
      const image = this.querySelector('.yg-buy-buttons-summary__image img');
      if (!image) return;

      const fallbackSrc = this.getAttribute('data-fallback-image-src');
      const nextSrc = variant.featured_image?.src || fallbackSrc;
      if (!nextSrc) return;

      image.src = nextSrc;
      image.removeAttribute('srcset');
    }

    updateVariantPrice(variant) {
      const price = this.querySelector('[data-yg-buy-buttons-price]');
      const compare = this.querySelector('[data-yg-buy-buttons-compare]');
      const save = this.querySelector('[data-yg-buy-buttons-save]');

      if (price) {
        price.innerHTML = theme.Currency.formatMoney(variant.price, this.moneyFormat);
      }

      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, this.moneyFormat);
          compare.classList.remove('hidden');
        }
        else {
          compare.innerHTML = '';
          compare.classList.add('hidden');
        }
      }

      if (save) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const savedAmount = theme.Currency.formatMoney(variant.compare_at_price - variant.price, this.moneyFormat);
          const template = save.getAttribute('data-save-template') || 'Save [[amount]]';
          save.innerHTML = template.replace('[[amount]]', savedAmount);
          save.classList.remove('hidden');
        }
        else {
          save.innerHTML = '';
          save.classList.add('hidden');
        }
      }
    }

    updateQuantityInputRules(variant) {
      const input = this.quantityInput;
      if (!input || !variant.quantity_rule) return;

      const rule = variant.quantity_rule;
      input.setAttribute('data-quantity-variant-id', variant.id);
      input.setAttribute('data-min', rule.min);
      input.setAttribute('min', rule.min);
      input.setAttribute('step', rule.increment);

      if (rule.max) {
        input.setAttribute('data-max', rule.max);
        input.setAttribute('max', rule.max);
      }
      else {
        input.removeAttribute('data-max');
        input.removeAttribute('max');
      }

      const currentValue = parseInt(input.value || rule.min, 10);
      if (Number.isNaN(currentValue) || currentValue < rule.min) {
        input.value = rule.min;
      }
    }
  }

  if (!window.customElements.get('yg-buy-buttons-summary')) {
    window.customElements.define('yg-buy-buttons-summary', YGBuyButtonsSummary);
  }

  class YGBuyNowButton extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    get button() {
      return this.querySelector('button');
    }

    get productForm() {
      const formId = this.getAttribute('data-product-form-id');
      return formId ? document.forms[formId] : null;
    }

    get token() {
      return this.getAttribute('data-storefront-access-token') || '';
    }

    get apiVersion() {
      return this.getAttribute('data-storefront-api-version') || '2026-07';
    }

    async handleClick() {
      if (!this.productForm || this.button?.disabled) return;

      // if (!this.token) {
      //   this.showError('Storefront access token is required for Buy Now.');
      //   return;
      // }

      const lines = this.getCartLines();
      if (lines.length === 0) {
        this.showError('Please select an available product.');
        return;
      }

      this.setLoading(true);
      this.showError(false);

      try {
        const response = await fetch(`/api/${this.apiVersion}/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': this.token
          },
          body: JSON.stringify({
            query: `
              mutation YGCartCreate($input: CartInput!) {
                cartCreate(input: $input) {
                  cart {
                    checkoutUrl
                  }
                  userErrors {
                    field
                    message
                  }
                }
              }
            `,
            variables: {
              input: { lines }
            }
          })
        });
        const json = await response.json();
        const errors = json.errors || json.data?.cartCreate?.userErrors;
        const checkoutUrl = json.data?.cartCreate?.cart?.checkoutUrl;

        if (!response.ok || errors?.length || !checkoutUrl) {
          const message = errors?.[0]?.message || 'Unable to create checkout. Please try again.';
          throw new Error(message);
        }

        window.location.href = checkoutUrl;
      }
      catch (error) {
        this.showError(error.message || 'Unable to create checkout. Please try again.');
        this.setLoading(false);
      }
    }

    getCartLines() {
      const formData = new FormData(this.productForm);
      const variantId = formData.get('id');
      const quantity = this.normalizeQuantity(formData.get('quantity') || '1', 1);
      const lines = [];

      if (variantId) {
        const mainLine = {
          merchandiseId: this.toVariantGid(variantId),
          quantity
        };
        const attributes = this.getLineAttributes(formData);
        if (attributes.length > 0) mainLine.attributes = attributes;
        lines.push(mainLine);
      }

      this.getBundleInputs().forEach((input) => {
        const bundleQuantity = this.normalizeQuantity(input.getAttribute('data-min') || '0', 0);
        if (input.value && bundleQuantity > 0) {
          lines.push({
            merchandiseId: this.toVariantGid(input.value),
            quantity: bundleQuantity
          });
        }
      });

      return lines;
    }

    getBundleInputs() {
      const formId = this.productForm.getAttribute('id');
      return Array.from(document.querySelectorAll(`[form="${formId}"] input[name="bundles"]:checked`));
    }

    getLineAttributes(formData) {
      const attributes = [];

      formData.forEach((value, name) => {
        const match = name.match(/^properties\[(.*?)\]$/);
        if (match && value !== '') {
          attributes.push({
            key: match[1],
            value: String(value)
          });
        }
      });

      return attributes;
    }

    normalizeQuantity(value, fallback) {
      const quantity = parseInt(value, 10);
      return Number.isNaN(quantity) || quantity < 1 ? fallback : quantity;
    }

    toVariantGid(id) {
      return String(id).startsWith('gid://') ? String(id) : `gid://shopify/ProductVariant/${id}`;
    }

    showError(message) {
      if (typeof this.productForm.handleErrorMessage === 'function') {
        this.productForm.handleErrorMessage(message);
        return;
      }

      const errorMessage = this.productForm.querySelector('.product-form__error-message');
      if (!errorMessage) return;

      errorMessage.toggleAttribute('hidden', !message);
      errorMessage.innerText = message || '';
    }

    setLoading(isLoading) {
      if (isLoading) {
        this.wasDisabled = this.button?.disabled === true;
        if (this.button) this.button.disabled = true;
      }
      else if (this.button && !this.wasDisabled) {
        this.button.disabled = false;
      }

      this.button?.toggleAttribute('aria-busy', isLoading);
      this.button?.toggleAttribute('aria-disabled', isLoading);
    }
  }

  if (!window.customElements.get('yg-buy-now-button')) {
    window.customElements.define('yg-buy-now-button', YGBuyNowButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-accessory-offer"] && !Shopify.designMode) return;
  try {
    class YGAccessoryOffer extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.handleInput = this.handleInput.bind(this);
      this.handleCartAdded = this.handleCartAdded.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('input', this.handleInput);
      document.addEventListener('ajaxProduct:added', this.handleCartAdded);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('input', this.handleInput);
      document.removeEventListener('ajaxProduct:added', this.handleCartAdded);
    }

    get controls() {
      return Array.from(this.querySelectorAll('[data-yg-accessory-control]'));
    }

    get targetCount() {
      const target = parseInt(this.getAttribute('data-target-count') || '3', 10);
      return Number.isNaN(target) || target < 1 ? 3 : target;
    }

    handleCartAdded() {
      this.controls.forEach((control) => {
        const input = control.querySelector('[data-yg-accessory-quantity]');
        if (input) input.value = '0';
      });
      this.update();
    }

    handleClick(event) {
      const minus = event.target.closest('[data-yg-accessory-minus]');
      const plus = event.target.closest('[data-yg-accessory-plus]');
      if (!minus && !plus) return;

      const control = event.target.closest('[data-yg-accessory-control]');
      const input = control?.querySelector('[data-yg-accessory-quantity]');
      if (!input || input.disabled) return;

      const currentValue = this.normalizeQuantity(input.value);
      input.value = String(plus ? currentValue + 1 : Math.max(0, currentValue - 1));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    handleInput(event) {
      if (!event.target.matches('[data-yg-accessory-quantity]')) return;
      event.target.value = String(this.normalizeQuantity(event.target.value));
      this.update();
    }

    normalizeQuantity(value) {
      const quantity = parseInt(value || '0', 10);
      return Number.isNaN(quantity) || quantity < 0 ? 0 : quantity;
    }

    update() {
      let total = 0;

      this.controls.forEach((control) => {
        const input = control.querySelector('[data-yg-accessory-quantity]');
        const bundleInput = control.parentElement?.querySelector('input[name="bundles"]');
        const quantity = this.normalizeQuantity(input?.value);
        total += quantity;

        if (bundleInput) {
          bundleInput.checked = quantity > 0;
          bundleInput.setAttribute('data-min', String(quantity));
        }
      });

      this.updateProgress(total);
      this.updateMessage(total);
      this.dispatchEvent(new CustomEvent('yg-accessory-offer:change', {
        bubbles: true,
        detail: { quantity: total }
      }));
    }

    updateProgress(total) {
      const fill = this.querySelector('[data-yg-accessory-progress]');
      const track = this.querySelector('.yg-accessory-offer__progress-track');

      const percent = Math.min(total, this.targetCount) / this.targetCount * 100;
      const progress = `${percent}%`;
      if (track) track.style.setProperty('--yg-accessory-progress', progress);
      if (fill) fill.style.setProperty('--yg-accessory-progress-scale', String(percent / 100));
    }

    updateMessage(total) {
      const message = this.querySelector('[data-yg-accessory-message]');
      if (!message) return;

      const remaining = Math.max(this.targetCount - total, 0);
      const discount = this.getAttribute('data-discount-text') || '';
      const template = remaining === 0
        ? this.getAttribute('data-reached-text')
        : this.getAttribute('data-progress-text');
      const html = (template || '')
        .replaceAll('[[count]]', String(total))
        .replaceAll('[[remaining_more]]', `<strong>${remaining} more</strong>`)
        .replaceAll('[[remaining]]', `<strong>${remaining}</strong>`)
        .replaceAll('[[discount]]', discount);

      message.innerHTML = html;
    }
  }

  if (!window.customElements.get('yg-accessory-offer')) {
    window.customElements.define('yg-accessory-offer', YGAccessoryOffer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
      #observedSection = null;
      static observer = null;
      static sectionToItem = new Map();
      static isScroll = false;

      constructor() {
        super();
        this.itemClick = this.itemClick.bind(this);
        this.sections = null;
      }

      connectedCallback() {
        this.sections = document.querySelectorAll('#main .shopify-section');
        this.addEventListener('click', this.itemClick);

        const sectionNumber = Number(this.getAttribute('data-section-number') || 0);
        if (!this.sections?.length || !Number.isFinite(sectionNumber) || sectionNumber <= 0) return;

        const section = this.sections[sectionNumber - 1];
        if (!section) return;

        this.#observedSection = section;
        YGAnchorItem.#ensureObserver();
        YGAnchorItem.sectionToItem.set(section, this);
        YGAnchorItem.observer.observe(section);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);

        if (this.#observedSection && YGAnchorItem.observer) {
          YGAnchorItem.sectionToItem.delete(this.#observedSection);
          YGAnchorItem.observer.unobserve(this.#observedSection);
        }
      }

      static #ensureObserver() {
        if (YGAnchorItem.observer) return;

        YGAnchorItem.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const item = YGAnchorItem.sectionToItem.get(entry.target);
              if (!YGAnchorItem.isScroll) {
                item && item.setActiveFromObserver();
              }
            });
          },
          {
            root: null,
            threshold: 0.01,
            rootMargin: '-20% 0px -70% 0px',
          }
        );
      }

      setActiveFromObserver() {
        let id = this.getAttribute('data-id');
        let $anchorList;
        if (id) {
          $anchorList = this.parentElement
            ? Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`))
            : [];
        } else {
          $anchorList = this.parentElement
            ? Array.from(this.parentElement.querySelectorAll('yg-anchor-item'))
            : [];
        }

        $anchorList.forEach((el, index) => {
          el.classList.toggle('active', el.getAttribute('data-section-number') === this.getAttribute('data-section-number'));

          if (el === this) {
            this.labelClick(index);
          }
        });

        document.dispatchEvent(new CustomEvent('YG:anchor-change', {
          bubbles: true,
        }));
      }

      labelClick(index) {
        // 添加新的活动状态
        const parent = this.parentElement;
        if (parent && this.isScrollable(parent)) {
          const containerRect = parent.getBoundingClientRect();
          const targetRect = this.getBoundingClientRect();
          const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 260;

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      isScrollable(el) {
        if (!el) return false;

        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;

        const canScrollVertically =
          (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally =
          (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

        return canScrollVertically || canScrollHorizontally;
      }

      itemClick() {
        const sectionNumber = this.getAttribute('data-section-number');
        YGAnchorItem.isScroll = true;
        this.setActiveFromObserver();
        if (sectionNumber == 0) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        } else {
          const section = this.sections[sectionNumber - 1];
          if (!section) return;
          const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }

        setTimeout(() => {
          YGAnchorItem.isScroll = false;
        }, 600);
      }
    }
    if (!window.customElements.get('yg-anchor-item')) {
      window.customElements.define('yg-anchor-item', YGAnchorItem);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-discount-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.customElements.get('yg-discount-card')) return;

    class YGDiscountCard extends HTMLElement {
      constructor() {
        super();
        this.timer = null;
        this.messageTimer = null;
        this.handleCopy = this.handleCopy.bind(this);
      }

      connectedCallback() {
        this.copyButton = this.querySelector('[data-copy-button]');
        this.codeElement = this.querySelector('[data-discount-code]');
        this.messageElement = this.querySelector('[data-copy-message]');
        this.countdownLabel = this.querySelector('[data-countdown-label]');
        this.countdownTime = this.querySelector('[data-countdown-time]');

        if (this.copyButton) {
          this.copyButton.addEventListener('click', this.handleCopy);
        }

        this.targetDate = this.parseDate(this.dataset.endTime);
        if (this.targetDate && this.countdownLabel && this.countdownTime) {
          this.updateCountdown();
          this.timer = window.setInterval(() => this.updateCountdown(), 1000);
        }
      }

      disconnectedCallback() {
        if (this.copyButton) {
          this.copyButton.removeEventListener('click', this.handleCopy);
        }

        this.clearTimer();
        window.clearTimeout(this.messageTimer);
      }

      parseDate(rawDate) {
        if (!rawDate) return null;

        const normalizedDate = rawDate.includes('T') ? rawDate : rawDate.replace(/-/g, '/');
        const parsedDate = new Date(normalizedDate);

        return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
      }

      clearTimer() {
        if (!this.timer) return;

        window.clearInterval(this.timer);
        this.timer = null;
      }

      updateCountdown() {
        const diff = this.targetDate.getTime() - Date.now();

        if (diff <= 0) {
          this.clearTimer();
          this.renderExpired();
          return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const template = this.dataset.countdownTemplate || '';

        this.countdownLabel.textContent = template.replace('[[day]]', String(days));
        this.countdownTime.textContent = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
      }

      renderExpired() {
        const expiredText = this.dataset.expiredText || '';

        if (!expiredText) {
          const countdown = this.countdownLabel ? this.countdownLabel.closest('.yg-discount-card__countdown') : null;
          if (countdown) countdown.hidden = true;
          return;
        }

        this.countdownLabel.textContent = expiredText;
        this.countdownTime.textContent = '';
      }

      pad(value) {
        return String(value).padStart(2, '0');
      }

      handleCopy() {
        const code = this.codeElement ? this.codeElement.textContent.trim() : '';
        if (!code) return;

        this.copyText(code).then((copied) => {
          if (copied) {
            this.showMessage();
          }
        });
      }

      copyText(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(text)
            .then(() => true)
            .catch(() => this.copyTextWithFallback(text));
        }

        return Promise.resolve(this.copyTextWithFallback(text));
      }

      copyTextWithFallback(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '0';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();

        return copied;
      }

      showMessage() {
        if (!this.messageElement) return;

        this.messageElement.textContent = this.dataset.copySuccess || this.messageElement.textContent;
        this.messageElement.hidden = false;
        window.clearTimeout(this.messageTimer);
        this.messageTimer = window.setTimeout(() => {
          this.messageElement.hidden = true;
        }, 2200);
      }
    }

    window.customElements.define('yg-discount-card', YGDiscountCard);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-help-shopping-card"] && !Shopify.designMode) return;
  try {
    class YGHelpShoppingCard extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    get button() {
      return this.querySelector('button');
    }

    handleClick() {
      const selector = this.getAttribute('data-chat-trigger-selector');
      if (!selector) return;

      const trigger = document.querySelector(selector);
      if (trigger && typeof trigger.click === 'function') {
        trigger.click();
      }
    }
  }

  if (!window.customElements.get('yg-help-shopping-card')) {
    window.customElements.define('yg-help-shopping-card', YGHelpShoppingCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // Observe only this snippet's lazy images.
      this.images.forEach((img) => {
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGImageLazyLoader is unavailable, falling back to direct image loading.');
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    getDirectPopupTemplate() {
      return Array.from(this.children).find((child) => child.matches('template, .yg-popup-template')) || null;
    }

    connectedCallback() {
      this.sectionsEl = {
        popupTemplate: this.getDirectPopupTemplate(),
      };

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }

      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      this.addEventListener('click', this.handleActivate);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivate);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    getPopupTemplate() {
      if (this.sectionsEl.popupTemplate) {
        return this.sectionsEl.popupTemplate;
      }

      if (!this.dataset.popupId) {
        return null;
      }

      return document.getElementById(`yg-popup-template-${this.dataset.popupId}`);
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.handleActivate();
    }

    handleActivate() {
      const popupTemplate = this.getPopupTemplate();

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate,
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass,
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-compare-modal-card"] && !Shopify.designMode) return;
  try {
    class YGProductCompareModalTable extends HTMLElement {
    connectedCallback() {
      this.handleChange = this.handleChange.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('change', this.handleChange);
      this.addEventListener('click', this.handleClick);
      this.setRowLabels();
      this.initializeColumns();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
      this.removeEventListener('click', this.handleClick);
    }

    handleChange(event) {
      if (!event.target.matches('[data-yg-compare-select]')) return;
      this.updateColumn(event.target);
    }

    handleClick(event) {
      const addButton = event.target.closest('.yg-product-compare-modal__add');
      if (!addButton || !this.contains(addButton)) return;
      this.addToCart(addButton);
    }

    get compareData() {
      if (this._compareData) return this._compareData;

      const dataEl = this.querySelector('[data-yg-compare-data]');
      try {
        this._compareData = JSON.parse(dataEl?.textContent || '{"options":[]}');
      }
      catch (error) {
        this._compareData = { options: [] };
      }

      return this._compareData;
    }

    get optionMap() {
      if (this._optionMap) return this._optionMap;

      this._optionMap = {};
      this.compareData.options.forEach((option) => {
        if (option?.value) this._optionMap[option.value] = option;
      });

      return this._optionMap;
    }

    initializeColumns() {
      this.querySelectorAll('[data-yg-compare-column]').forEach((column) => {
        const select = column.querySelector('[data-yg-compare-select]');
        if (select) {
          this.updateColumn(select);
          return;
        }

        this.updateSpecificationColumn(column.dataset.ygCompareColumn, column.dataset.ygCompareHandle);
      });
    }

    setRowLabels() {
      this.querySelectorAll('.yg-product-compare-modal__row').forEach((row) => {
        const label = row.querySelector('.yg-product-compare-modal__row-label')?.textContent?.trim() || '';
        row.querySelectorAll('[data-yg-compare-spec-cell]').forEach((cell) => {
          cell.setAttribute('data-row-label', label);
        });
      });
    }

    updateColumn(select) {
      const option = select.selectedOptions[0];
      const column = select.closest('[data-yg-compare-column]');
      if (!option || !column) return;

      const image = column.querySelector('.yg-product-compare-modal__image img');
      const price = column.querySelector('[data-yg-compare-price]');
      const link = column.querySelector('[data-yg-compare-link]');
      const addButton = column.querySelector('[data-yg-compare-add]');
      const handle = option.value;

      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
        image.alt = option.dataset.title || '';
      }

      if (price) price.textContent = option.dataset.price || '';
      if (link) link.href = option.dataset.url || '#';
      if (addButton) {
        addButton.dataset.variantId = option.dataset.variantId || '';
        addButton.disabled = option.dataset.available !== 'true';
      }

      column.dataset.ygCompareHandle = handle;
      this.updateSpecificationColumn(column.dataset.ygCompareColumn, handle);
    }

    updateSpecificationColumn(columnIndex, handle) {
      const option = this.optionMap[handle];
      const specifications = option?.data?.specification_list || [];

      this.querySelectorAll(`[data-yg-compare-spec-cell][data-column-index="${columnIndex}"]`).forEach((cell) => {
        const rowIndex = parseInt(cell.dataset.rowIndex || '0', 10);
        const value = specifications[rowIndex];
        cell.textContent = value === '.' ? '' : (value || '-');
      });
    }

    async addToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId || button.disabled) return;

      this.showError(false);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        const config = theme.utils.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ],
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        });

        const response = await fetch(theme.routes.cart_add_url, config);
        const parsedState = await response.json();

        if (parsedState.status) {
          throw new Error(parsedState.description || parsedState.message || 'Unable to add product to cart.');
        }

        const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
        cartJson.sections = parsedState.sections;
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'yg-product-compare-modal',
          productVariantId: variantId,
          cart: cartJson
        });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: parsedState
          }
        }));
        document.querySelector('cart-drawer')?.show(button);
      }
      catch (error) {
        this.showError(error.message || 'Unable to add product to cart.');
      }
      finally {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }

    showError(message) {
      const errorMessage = this.querySelector('.product-form__error-message');
      if (!errorMessage) return;

      errorMessage.toggleAttribute('hidden', !message);
      errorMessage.innerText = message || '';
    }
  }

  if (!window.customElements.get('yg-product-compare-modal-table')) {
    window.customElements.define('yg-product-compare-modal-table', YGProductCompareModalTable);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-media-tabs"] && !Shopify.designMode) return;
  try {
    class YGProductMediaTabs extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleImageSlideChange = this.handleImageSlideChange.bind(this);
      this.handleContentMutation = this.handleContentMutation.bind(this);
      this.handleThumbPrevious = this.handleThumbPrevious.bind(this);
      this.handleThumbNext = this.handleThumbNext.bind(this);
    }

    connectedCallback() {
      this.bindTabButtons();
      this.mutationObserver = new MutationObserver(this.handleContentMutation);
      this.mutationObserver.observe(this, { childList: true });

      this.initWhenReady();
    }

    disconnectedCallback() {
      this.unbindTabButtons();
      this.mutationObserver?.disconnect();
      this.destroySwipers();
    }

    bindTabButtons() {
      this.unbindTabButtons();
      this.tabButtons = Array.from(this.querySelectorAll('[data-tab]'));
      this.tabButtons.forEach((button) => {
        button.addEventListener('click', this.handleTabClick);
      });
      this.thumbPreviousButton = this.querySelector('[data-thumb-prev]');
      this.thumbNextButton = this.querySelector('[data-thumb-next]');
      this.thumbPreviousButton?.addEventListener('click', this.handleThumbPrevious);
      this.thumbNextButton?.addEventListener('click', this.handleThumbNext);
    }

    unbindTabButtons() {
      this.tabButtons?.forEach((button) => {
        button.removeEventListener('click', this.handleTabClick);
      });
      this.thumbPreviousButton?.removeEventListener('click', this.handleThumbPrevious);
      this.thumbNextButton?.removeEventListener('click', this.handleThumbNext);
      this.tabButtons = [];
      this.thumbPreviousButton = null;
      this.thumbNextButton = null;
    }

    handleContentMutation() {
      clearTimeout(this.rebuildTimer);
      this.rebuildTimer = setTimeout(() => {
        this.bindTabButtons();
        this.destroySwipers();
        this.initWhenReady();
      }, 0);
    }

    destroySwipers() {
      this.imageSwiper?.destroy(true, true);
      this.thumbsSwiper?.destroy(true, true);
      this.richSwipers?.forEach((swiper) => swiper.destroy(true, true));
      this.imageSwiper = null;
      this.thumbsSwiper = null;
      this.richSwipers = [];
    }

    initWhenReady() {
      if (window.Swiper) {
        this.initSwipers();
        return;
      }

      window.setTimeout(() => this.initWhenReady(), 50);
    }

    initSwipers() {
      if (this.imageSwiper) return;

      const thumbsElement = this.querySelector('.yg-product-media-tabs__thumbs');
      const imageElement = this.querySelector('.yg-product-media-tabs__image-main');

      if (imageElement && thumbsElement) {
        this.thumbsSwiper = new Swiper(thumbsElement, {
          slidesPerView: 3,
          spaceBetween: 8,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          allowTouchMove: true,
          on: {
            slideChange: () => this.updateThumbMore(),
          },
        });
      }

      if (imageElement) {
        this.imageSwiper = new Swiper(imageElement, {
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: false,
          navigation: {
            nextEl: this.querySelector('[data-image-next]'),
            prevEl: this.querySelector('[data-image-prev]'),
          },
          thumbs: this.thumbsSwiper ? { swiper: this.thumbsSwiper } : undefined,
          on: {
            slideChange: this.handleImageSlideChange,
          },
        });

        this.handleImageSlideChange(this.imageSwiper);
      }

      this.richSwipers = Array.from(this.querySelectorAll('[data-rich-swiper]')).map((swiperElement) => {
        return new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: false,
          navigation: {
            nextEl: swiperElement.querySelector('[data-rich-next]'),
            prevEl: swiperElement.querySelector('[data-rich-prev]'),
          },
        });
      });

      this.removeModelButtons();
    }

    handleTabClick(event) {
      const button = event.currentTarget;
      const tab = button.getAttribute('data-tab');
      const imageIndex = button.getAttribute('data-image-index');

      this.setActiveTab(tab);

      if (tab === 'image' && imageIndex !== null && this.imageSwiper) {
        this.imageSwiper.slideTo(Number(imageIndex));
      }

      if (tab !== 'image') {
        this.pauseInactiveMedia(tab);
      }
    }

    handleThumbPrevious() {
      this.setActiveTab('image');
      this.imageSwiper?.slidePrev();
    }

    handleThumbNext() {
      this.setActiveTab('image');
      this.imageSwiper?.slideNext();
    }

    setActiveTab(tab) {
      this.setAttribute('data-active-tab', tab);

      this.querySelectorAll('[data-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-panel') === tab);
      });

      this.querySelectorAll('[data-tab]').forEach((button) => {
        if (button.hasAttribute('data-image-index')) return;

        const isActive = button.getAttribute('data-tab') === tab;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (tab === 'image') {
        this.imageSwiper?.update();
        this.thumbsSwiper?.update();
        this.pauseInactiveMedia(tab);
      } else {
        const activePanel = this.querySelector(`[data-panel="${tab}"]`);
        activePanel?.querySelectorAll('[data-rich-swiper]').forEach((swiperElement) => {
          swiperElement.swiper?.update();
        });
        const deferredMedia = activePanel?.querySelector('.deferred-media');
        if (deferredMedia && typeof deferredMedia.play === 'function') deferredMedia.play();
      }
    }

    handleImageSlideChange(swiper) {
      const activeIndex = (swiper?.realIndex ?? swiper?.activeIndex ?? 0);
      const current = activeIndex + 1;

      this.querySelectorAll('[data-image-current]').forEach((element) => {
        element.textContent = current;
      });

      this.querySelectorAll('[data-image-index]').forEach((button) => {
        const isActive = Number(button.getAttribute('data-image-index')) === activeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this.syncThumbWindow(activeIndex);
      this.updateThumbMore();
    }

    syncThumbWindow(activeIndex) {
      if (!this.thumbsSwiper) return;

      const total = this.getImageThumbs().length;
      const maxStart = Math.max(total - 3, 0);
      const start = Math.min(activeIndex, maxStart);

      if (this.thumbsSwiper.activeIndex !== start) {
        this.thumbsSwiper.slideTo(start);
      }
    }

    updateThumbMore() {
      const thumbs = this.getImageThumbs();
      thumbs.forEach((thumb) => {
        thumb.querySelector('.yg-product-media-tabs__thumb-more')?.remove();
      });

      if (!this.thumbsSwiper || thumbs.length <= 3) return;

      const start = this.thumbsSwiper.activeIndex || 0;
      const overlayIndex = Math.min(start + 2, thumbs.length - 1);
      const remaining = thumbs.length - overlayIndex - 1;
      if (remaining <= 0) return;

      const overlay = document.createElement('span');
      overlay.className = 'yg-product-media-tabs__thumb-more';
      overlay.textContent = `+${remaining}`;
      thumbs[overlayIndex]?.appendChild(overlay);
    }

    getImageThumbs() {
      return Array.from(this.querySelectorAll('[data-image-index]'));
    }

    pauseInactiveMedia(activeTab) {
      this.querySelectorAll('[data-panel]').forEach((panel) => {
        if (panel.getAttribute('data-panel') === activeTab) return;

        panel.querySelectorAll('.deferred-media').forEach((media) => {
          if (typeof media.pause === 'function') media.pause();
        });
      });
    }

    removeModelButtons() {
      this.querySelectorAll('[data-panel="model"] .play-button, [data-panel="model"] .button--close').forEach((button) => {
        button.remove();
      });
    }
  }

  if (!window.customElements.get('yg-product-media-tabs')) {
    window.customElements.define('yg-product-media-tabs', YGProductMediaTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
